'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _HighlightedJob = require('./HighlightedJob');

var _HighlightedJob2 = _interopRequireDefault(_HighlightedJob);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'highlighted-jobs';

function HighlightedJobs(_ref) {
  var slideCarousel = _ref.slideCarousel,
      page = _ref.page,
      highlightedJobs = _ref.highlightedJobs;

  return _react2.default.createElement(
    'section',
    { className: CLASS_NAME },
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'h3',
        null,
        'What are Financial Services Careers?'
      ),
      _react2.default.createElement(
        'h4',
        null,
        'There are thousands of career opportunities'
      ),
      _react2.default.createElement(
        'div',
        { className: 'slides-container' },
        _react2.default.createElement('a', {
          className: 'arrow arrow-left',
          onClick: function onClick() {
            slideCarousel(0);
          }
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'slides'
          },
          _react2.default.createElement(
            'div',
            {
              id: 'overflow',
              className: 'slides-overflow left-' + page
            },
            highlightedJobs.map(function (job, key) {
              return _react2.default.createElement(_HighlightedJob2.default, {
                key: key,
                image: job.image,
                imageAlt: job.imageAlt,
                title: job.title,
                salaryRange: job.salaryRange,
                educationRequirement: job.educationRequirement,
                careerLevel: job.careerLevel,
                fullSlug: job.fullSlug,
                match: (job.matches || {}).match
              });
            })
          )
        ),
        _react2.default.createElement('a', {
          className: 'arrow arrow-right',
          onClick: function onClick() {
            slideCarousel(1);
          }
        })
      )
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(HighlightedJobs);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/HighlightedJobs/HighlightedJobs.jsx
// module id = 1073
// module chunks = 0